export default __webpack_public_path__ + "static/media/guide_044.aa38ac44.md";